var React = require('react');

function WeightHanging (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M164.47 128a96 96 0 1 1 181.06 0H255a32 32 0 1 0-32-32 32 32 0 0 0 32 32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M510.28 445.85l-73-292.13c-3.8-15.19-16.44-25.72-30.87-25.72H105.64c-14.43 0-27.08 10.54-30.87 25.72l-73 292.13C-6.61 479.16 16.38 512 48 512h416c31.62 0 54.61-32.84 46.28-66.15z","className":"fa-primary","key":2})]);
}

WeightHanging.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = WeightHanging;

WeightHanging.default = WeightHanging;
